import React, {useState} from "react";
import SpendTracker from "./SpendTarcker";
import TotalSpendChart from "./TotalSpendChart";
import HighestSpendOnSupplierTable from "./HighestSpendOnSupplierTable";


const MetricPage = () => {
  const [activeTab, setActiveTab] = useState("Last 3 Months");
  const tabs = ["Monthly", "Last 3 Months", "Yearly"];

  return (
    <div className="flex flex-col gap-6 pl-4 pr-8">
        <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-medium text-black">Spend Tracker</h1>
        <div className="flex gap-2 bg-white rounded-xl p-1 shadow">
          {tabs.map((tab, i) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`
                px-4 py-1 border-r last:border-r-0
                ${
                  activeTab === tab
                    ? "text-blue-600 font-semibold"
                    : "text-gray-600 hover:text-gray-400"
                }
              `}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
      <SpendTracker activeTab={activeTab}/>
      <TotalSpendChart activeTab={activeTab}/>
      {/* <HighestSpendOnSupplierTable/> */}

    </div>

  )
}

export default MetricPage;